import { render } from "./LimitLengthText.vue?vue&type=template&id=32074efe"
import script from "./LimitLengthText.vue?vue&type=script&lang=js"
export * from "./LimitLengthText.vue?vue&type=script&lang=js"

import "./LimitLengthText.vue?vue&type=style&index=0&id=32074efe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__